var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSpiritualPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3721_23163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3721_23163)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.504 83.8912H32.2718C26.691 81.6133 21.6137 78.258 17.3301 74.0171C17.5912 57.402 35.9509 67.0387 40.2827 55.1589C41.0507 52.5404 41.1648 49.7735 40.615 47.1006L49.4684 47.2786L58.322 47.1006C57.7603 49.7725 57.8745 52.5423 58.6543 55.1589C62.9742 67.0269 81.3339 57.3545 81.6068 74.0171C77.3316 78.2571 72.2622 81.6125 66.6888 83.8912H49.504Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7299 52.4772H49.5874C48.3047 52.6047 47.0096 52.4549 45.7897 52.0381C44.8166 51.6227 44.3418 50.6614 43.0008 49.3678C41.814 48.2641 39.8083 47.1485 39.298 45.9499C38.6927 44.4901 38.8351 42.8998 38.5859 40.7755C37.5178 41.357 36.3903 38.3307 36.2123 37.3337C35.88 35.8621 34.8237 33.3699 34.4914 31.6965C34.3015 30.7352 34.4202 29.9756 34.7406 29.7264C35.4408 29.2042 36.1767 29.5128 37.2448 31.0081C37.1215 29.191 37.1811 27.366 37.4228 25.5608C38.8826 17.1701 59.3904 12.506 61.6928 25.5608C61.9225 27.367 61.9821 29.1908 61.8708 31.0081C62.9389 29.5484 63.651 29.2398 64.363 29.762C64.6835 30.0112 64.8021 30.7708 64.6123 31.7321C64.28 33.4055 63.2237 35.8977 62.8914 37.3694C62.6659 38.3544 61.5503 41.3332 60.5178 40.8348C60.2804 42.8879 60.411 44.3952 59.8176 45.8668C59.3191 47.0536 57.2897 48.2404 56.1504 49.3204C54.8212 50.6377 54.3465 51.5871 53.3733 52.0263C52.2052 52.4359 50.9626 52.5897 49.7299 52.4772V52.4772Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1875 23.4598C38.4548 25.5367 38.0275 33.6663 38.158 36.5146C35.2148 25.8334 33.6363 18.2379 40.0094 13.4433C48.3882 7.14142 57.8113 11.0697 59.3304 13.6094C65.478 17.0037 63.3418 26.5692 61.4904 34.9717C61.1106 30.1332 60.1748 25.3546 58.7014 20.7302C54.0136 17.7276 44.6024 18.3091 40.1875 23.4598Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7417 56.2861C48.3017 56.8805 50.9665 56.8561 53.5152 56.2148L53.3253 61.4605C53.3253 61.4605 49.6937 63.8341 49.5157 63.8341C49.3377 63.8341 45.9553 61.6148 45.9553 61.6148L45.7417 56.2861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5039 56.6547C50.8569 56.6612 52.205 56.4936 53.5153 56.1562L53.3254 61.4019C53.3254 61.4019 49.6938 63.7755 49.5158 63.7755L49.5039 56.6547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5966 56.4641L46.3355 56.3692L39.0723 54.4229L38.7993 56.6184C34.4794 60.4399 26.9314 59.977 21.0686 63.0864C17.6032 64.9378 16.4995 67.2402 14.9922 71.5839L4.07373 102.856H82.7107C82.5445 92.3765 84.8706 71.5839 81.9155 67.2521C76.48 59.265 65.7989 61.5911 60.2091 56.6303L59.9361 54.4347C58.6544 54.5178 53.9309 57.9951 52.6611 58.1138C52.5744 58.1022 52.4866 58.1022 52.4 58.1138V60.7366H46.5966V56.4641Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4472 56.4641L52.7083 56.3692L59.9833 54.4229L60.2563 56.6184C64.5643 60.4399 72.1242 59.977 77.9751 63.0864C81.4406 64.9378 82.5443 67.2402 84.0634 71.5839L94.97 102.856H49.5039V60.7603H52.4472V56.4641Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6435 80.6748L20.3447 102.856H24.5935L27.6435 80.6748Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.353 80.6748L78.6518 102.856H74.4031L71.353 80.6748Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 73.8384L49.2762 64L63 96.1616L41.7239 106L28 73.8384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8441 75.5949L42.6846 74.2937L43.8552 76.8488L46.5242 75.6261L47.8709 78.5658L45.2019 79.7885L47.6825 85.2034L44.842 86.5046L42.3614 81.0898L39.6886 82.3142L38.3419 79.3745L41.0147 78.1501L39.8441 75.5949Z",
    fill: "#B9D6EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3143 92.9582L47.7002 92.4361C43.4396 92.4361 40.9236 92.5429 36.7699 91.5222C35.856 91.2967 35.144 90.9407 34.2776 91.5222C33.4112 92.1038 33.2807 93.3618 34.776 94.2162C34.5299 94.3639 34.331 94.5787 34.2028 94.8355C34.0746 95.0924 34.0224 95.3804 34.0523 95.6659C34.0822 95.9514 34.193 96.2224 34.3717 96.447C34.5504 96.6716 34.7895 96.8406 35.0609 96.934C34.3607 97.9072 34.598 99.1058 36.3782 99.8298C35.049 100.269 35.5475 101.325 36.58 101.895C37.739 102.478 38.9273 103.001 40.1404 103.461C43.2016 103.48 46.2463 103.012 49.16 102.073L50.5723 95.5455L49.3143 92.9582Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.314 93.2788C47.7237 92.2344 47.3321 90.0507 46.4064 88.4604C45.7299 87.2736 45.0178 87.1668 42.668 85.6595C41.7199 84.8215 40.8204 83.9299 39.9739 82.9893C36.9713 86.3954 43.1664 87.3448 42.1814 90.11C41.9322 90.834 41.1014 91.3799 40.0451 92.3649L42.217 94.0739L49.314 93.2788Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9932 90.7988L86.6976 93.2911C97.6636 93.9438 98.2926 107.675 86.5196 106.975L48.9932 104.494V90.7988Z",
    fill: "#292929"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSpiritualPerson);
export default __webpack_public_path__ + "static/media/imgSpiritualPerson.39fff3fe7445c76dc8fd9fec24709aeb.svg";
export { ForwardRef as ReactComponent };